import { apm } from "@elastic/apm-rum";
import { CloudDownloadOutlined } from "@mui/icons-material";
import { IconButton, Link, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { useSnackbar } from "shared/common/contexts/SnackbarProvider";
import useAuth from "shared/common/hooks/UseAuth";
import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";

export default function PointCloudExportButton() {
  const changeShowStreetMap = defaultStore(
    (state) => state.changeShowStreetMap
  );
  const changeShowPCLExport = defaultStore(
    (state) => state.changeShowPCLExport
  );
  const projectConfig = defaultStore((state) => state.projectConfig);

  const { t } = useTranslation();
  const { userData } = useAuth();
  const { showMessage } = useSnackbar();

  return (
    <Tooltip
      title={t("tooltip.pointcloud_export")}
      placement="right"
      enterDelay={400}
      classes={{
        tooltip: "infra3d-buttonDescription",
      }}
    >
      <IconButton
        className="onboarding-point-cloud-export"
        sx={{
          width: "40px",
          height: "40px",
          mx: "auto",
          color: "white",
          "@media (hover: hover)": {
            ":hover": { color: "secondary.main" },
          },
        }}
        classes={{
          root: "infra3d-iconButtonRipple",
        }}
        onClick={() =>
          monitor(apm, "point-cloud-export | Toolbar", () => {
            // check if user has the addon point-cloud-export licensed
            const userAllowedByAddon =
              userData?.scope.includes("addon/pcexport");
            // check if user has the same scope (permission) as the collection in the project
            const userAllowedByCollection = userData?.scope.includes(
              `lidargate/${projectConfig?.collection}`
            );

            if (userAllowedByAddon && userAllowedByCollection) {
              changeShowPCLExport(true);
              changeShowStreetMap(true);
            } else {
              showMessage(
                <>
                  {!userAllowedByAddon
                    ? t("pointcloud_export.no_license")
                    : t("pointcloud_export.no_permission")}{" "}
                  <Link
                    href={String(
                      !userAllowedByAddon
                        ? t("urls.pointcloud_export.no_license.href")
                        : "mailto:" + t("general.email_support")
                    )}
                    target="_blank"
                    sx={{
                      color: "primary.contrastText",
                      textDecoration: "underline",
                    }}
                  >
                    {!userAllowedByAddon
                      ? t("urls.pointcloud_export.no_license.text")
                      : t("general.email_support")}
                  </Link>
                </>,
                "warning"
              );
            }
          })
        }
        disableRipple={true}
      >
        {/* <PointCloud /> */}
        <CloudDownloadOutlined />
      </IconButton>
    </Tooltip>
  );
}
